import React, { Component } from 'react';
import { HashRouter, Switch, Route } from 'react-router-dom';
import DownloadExperience from '../page/download';
import DoubleShareActivity from '../page/share';

export default class RouteConfig extends Component {
    render() {
        return (
            <HashRouter>
                <Switch>
                    <Route path="/agent" exact component={DownloadExperience} />
                    <Route path="/dbclock-share-activity" exact component={DoubleShareActivity} />
                </Switch>
            </HashRouter>
        );
    }
}